<template>
  <v-text-field
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    :disabled="disabled"
    :placeholder="fallbackColor"
    :hint="$t('postMessageColorHint')"
    persistent-hint
    :rules="[colorRule]"
    variant="outlined"
    rounded
    clearable
    class="search-field ml-3 mr-3"
    :maxlength="7"
  >
    <!-- Swatch doubles as the native picker and shows the colour the preview uses. -->
    <template #prepend-inner>
      <div class="pmc-swatch" :style="{ backgroundColor: previewColor }">
        <input
          type="color"
          :value="previewColor"
          :disabled="disabled"
          class="pmc-swatch-input"
          :aria-label="$t('postMessageColor')"
          @change="$emit('update:modelValue', $event.target.value.toUpperCase())"
        />
      </div>
    </template>
  </v-text-field>
</template>

<script>
export const POST_MESSAGE_HEX = /^#[0-9a-f]{6}$/i;

/** Returns the colour to render: the configured one when valid, otherwise the fallback. */
export function resolvePostMessageColor(color, fallback) {
  const value = (color || '').trim();
  return POST_MESSAGE_HEX.test(value) ? value : fallback;
}

/** True when the value is empty (app default) or a valid #RRGGBB colour. */
export function isValidPostMessageColor(color) {
  const value = (color || '').trim();
  return !value || POST_MESSAGE_HEX.test(value);
}

export default {
  name: 'PostMessageColorField',
  props: {
    modelValue: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    // Colour shown in the swatch/preview when nothing is configured (the app default).
    fallbackColor: { type: String, default: '#BCBEC0' },
  },
  emits: ['update:modelValue'],
  computed: {
    previewColor() {
      return resolvePostMessageColor(this.modelValue, this.fallbackColor);
    },
  },
  methods: {
    colorRule(value) {
      return isValidPostMessageColor(value) || this.$t('taxHistoryStyleColorInvalid');
    },
  },
};
</script>

<style scoped>
.pmc-swatch {
  position: relative;
  width: 26px;
  height: 26px;
  margin: 0 8px 0 0;
  align-self: center;
  flex-shrink: 0;
  border-radius: 6px;
  border: 1.5px solid rgba(0, 0, 0, 0.12);
  cursor: pointer;
}

.pmc-swatch-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
</style>
